export default "__VITE_ASSET__fC3lIOYd__"